import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import { Badge } from "@/client/components/shad/badge";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/client/components/shad/breadcrumb";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";
import ChannelsConfigForm from "@/client/forms/channels";

import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/settings/channels/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Channels</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <ChannelsConfigForm />
        </LayoutBody>
        <LayoutAside>
          <div className="h-full animate-in fade-in duration-500">
            <Card>
              <CardHeader>
                <CardTitle>
                  Channels status{" "}
                  <Badge className="bg-lime-50 text-lime-700 dark:bg-lime-950 dark:text-lime-300">
                    Active
                  </Badge>
                </CardTitle>
                <CardDescription>Using local offline maps</CardDescription>
              </CardHeader>
              <CardContent>Map content</CardContent>
            </Card>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
